import { createStore } from 'satcheljs';
import type FileProviderStore from './schema/FileProviderStore';
import getDefaultFileProviderStore from '../utils/getDefaultFileProviderStore';

const getStore = createStore<FileProviderStore>('fileProviderStore', getDefaultFileProviderStore());
export default getStore;
